module.exports = __webpack_public_path__ + "static/media/buscar.2584704d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Others/buscar.svg
// module id = 1825
// module chunks = 0